import { ConnectedRouter } from 'connected-react-router';
import React from 'react';
import { CookiesProvider } from 'react-cookie';
import { Provider as StoreProvider } from 'react-redux';

import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useWBDevelopmentInProductionIndicator } from '@workbuzz/shared-ui';
import { getAppConfig } from 'app/getConfig';
import { WBGrowthBookProvider } from 'component/WBGrowthBookProvider/WBGrowthBookProvider';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { store } from 'reduxStore/appStore';
import { AppRoutes } from 'router/AppRoutes';
import { useInitializeGTM } from 'shared/hooks/useInitializeGTM';
import { useRedirectToLogin } from 'shared/hooks/useRedirectToLogin';
import { LanguageProvider } from 'translations/LanguageProvider';

import history from './history';
import { workbuzzTheme } from './theme/workbuzzTheme';

export const App = () => {
  useInitializeGTM();
  useRedirectToLogin();
  useWBDevelopmentInProductionIndicator(getAppConfig().NODE_ENV === 'development');

  return (
    <PostHogProvider client={posthog}>
      <LanguageProvider>
        <StoreProvider store={store}>
          <WBGrowthBookProvider>
            <CookiesProvider defaultSetOptions={{ path: '/' }}>
              <ConnectedRouter history={history}>
                <ThemeProvider theme={workbuzzTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <CssBaseline />
                    <AppRoutes />
                  </LocalizationProvider>
                </ThemeProvider>
              </ConnectedRouter>
            </CookiesProvider>
          </WBGrowthBookProvider>
        </StoreProvider>
      </LanguageProvider>
    </PostHogProvider>
  );
};
